<div
  class="active-user-avatar"
  [matTooltip]="tooltipText"
  [ngClass]="size">
  <img
    *ngIf="user?.avatar"
    [src]="user.avatar"
    [alt]="user.first_name"
    class="w-6 h-6 rounded-full"
    onerror="this.src='/assets/images/profile-default.png'" />
  <div
    *ngIf="!user?.avatar"
    class="w-6 h-6 rounded-full bg-smoke-darker text-white text-xs flex items-center justify-center">
    {{ initials }}
  </div>
</div>
